/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $InspectionSummary = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        submittedDate: {
    type: 'string',
    isRequired: true,
},
        submittedTime: {
    type: 'string',
    isRequired: true,
},
        room: {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
    },
    isRequired: true,
},
        bed: {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
    },
    isRequired: true,
},
        patient: {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
    },
    isRequired: true,
},
        inspectedBy: {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
    },
    isRequired: true,
},
        idata: {
    type: 'array',
    contains: {
        type: 'Datum',
    },
},
        created_at: {
    type: 'string',
    isRequired: true,
},
    },
};